<template>
  <div>
    <info-text-block v-if="jobsList.length">
      <div class="paragraph-dark-gray paragraph-s inner">
        <p class="paragraph-dark-gray paragraph-s paragraph-bold">{{ labels.textEarlyBird }}</p>
        {{ labels.textNotVisibleJobs }}
        <span class="paragraph-secondary paragraph-s paragraph-bold">{{ labels.textIamInterested }}</span>
        {{ labels.textApplyToPosition }}
      </div>
    </info-text-block>

    <recommended-jobs-card-list
      v-if="jobsList.length"
      :items="jobsList"
      :show-items-amount="showItemsAmount"
      :is-all-items-shown="isAllItemsShown"
      :clickable="clickable"
      :show-more-less="showMoreLess"
      @on-item-click="handleItemCLick"
      @on-show-more="$emit('on-show-more')"
      @on-show-less="$emit('on-show-less')">
    </recommended-jobs-card-list>
  </div>
</template>

<script>

import InfoTextBlock from 'top20common/components/text-blocks/InfoTextBlock';

import RecommendedJobsCardList from '../recommended-jobs/RecommendedJobsCardList';

export default {
  props: {
    jobsList: Array,
    clickable: Boolean,
    showItemsAmount: Number,
    isAllItemsShown: Boolean,
    showMoreLess: Boolean
  },
  computed: {
    labels() {
      return {
        textEarlyBird: this.$gettext('Be an early bird!'),
        textIamInterested: this.$gettext('I’m interested'),
        textNotVisibleJobs: this.$gettext('These openings are not ready to be publicly visible yet. Click'),
        textApplyToPosition: this.$gettext('to be the first ones to learn more and apply to the positions.')
      };
    }
  },
  methods: {
    handleItemCLick(item) {
      this.$emit('on-item-click', item);
    }
  },
  components: {
    RecommendedJobsCardList,
    InfoTextBlock
  }
};
</script>

<style lang="scss" scoped>
.info-text-block p {
  margin-bottom: 5px;
}
</style>
